/* IMPORTS */
import {
  ComposedChart,
  Label,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import moment from "moment";
import gettext from "../../../shared/utils/gettext";
import { DacomBrush } from "../../../cropfield/cropfield_timeline";
import React from "react";
import CFTranslateFunction from "../../translations";

/* CorrelationToolDataSelection Component */
export const DataTimeline = (props) => {
  const { graphData, selectedDs, setSelectedDs, initBrushState } = props;

  /* Function altering the tooltip shown when hovering over datapoints within the timeline */
  const DatasetTooltip = (props) => {
    const { active, payload, label } = props;
    if (!active || !payload || payload.length === 0) return null;
    return (
      <div className="growth-tooltip">
        <div className="text-muted">{moment.unix(label).format("LL")}</div>
        {payload[0].payload.ds.map((ds) => (
          <div key={ds.uuid}>
            <div className="font-weight-bold">
              {ds.name || CFTranslateFunction(ds.data_type) || ds.data_type}
            </div>
          </div>
        ))}
      </div>
    );
  };

  /* JSX */
  return (
    <ResponsiveContainer width="100%" height={124} className="bg-white">
      <ComposedChart
        allowDataOverflow
        data={graphData}
        onClick={(clickData) => {
          if (!clickData) return;
          const d = graphData.find((d) => d.unix === clickData.activeLabel);
          if (d && d.ds) {
            setSelectedDs(d.ds);
          }
        }}
      >
        <XAxis
          dataKey="unix"
          domain={["dataMin", "dataMax"]}
          name="Date"
          tickFormatter={(date) => moment.unix(date).format("LL")}
          type="number"
          scale="time"
          padding={{ left: 30, right: 30 }}
        />
        {graphData.some((d) => d.machine === 0) && (
          <Line
            dataKey="machine"
            name={gettext("machines")}
            fill="blue"
            stroke="blue"
            strokeWidth={0}
            legendType="rect"
            dot={{ r: 5, stroke: "black", strokeWidth: 1 }}
            connectNulls
          />
        )}
        {graphData.some((d) => d.sensor === 0) && (
          <Line
            dataKey="sensor"
            name={gettext("sensors")}
            fill="red"
            stroke="red"
            strokeWidth={0}
            legendType="rect"
            dot={{ r: 5, stroke: "black", strokeWidth: 1 }}
            connectNulls
          />
        )}
        {graphData.some((d) => d.image === 0) && (
          <Line
            dataKey="image"
            name={gettext("images")}
            fill="green"
            stroke="green"
            strokeWidth={0}
            legendType="rect"
            dot={{ r: 5, stroke: "black", strokeWidth: 1 }}
            connectNulls
          />
        )}
        {graphData.some((d) => d.other === 0) && (
          <Line
            dataKey="other"
            name={gettext("other")}
            stroke="purple"
            fill="purple"
            strokeWidth={0}
            legendType="rect"
            dot={{ r: 5, stroke: "black", strokeWidth: 1 }}
            connectNulls
          />
        )}
        {selectedDs && selectedDs.length > 0 && (
          <ReferenceLine
            x={moment(selectedDs[0].recording_datetime).startOf("day").unix()}
            stroke="#A9B6BA"
          >
            <Label
              value={moment(selectedDs[0].recording_datetime).format("LL")}
              position={
                moment(selectedDs[0].recording_datetime).unix() >
                (graphData[graphData.length - 1].unix + graphData[0].unix) / 2
                  ? "insideTopRight"
                  : "insideTopLeft"
              }
            />
          </ReferenceLine>
        )}
        <DacomBrush
          key="dacom_brush"
          dataKey="unix"
          stroke="#FFCF4E"
          travellerWidth={20}
          height={20}
          tickFormatter={(v) => {
            return moment.unix(v).format("LL");
          }}
          startIndex={initBrushState.startIndex}
        />
        <Legend verticalAlign="top" align="right" height={24} />
        <Tooltip content={<DatasetTooltip />} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
